export default "__VITE_ASSET__326bab59__"